<template>
    <div class="text-xs-center">
        <v-menu v-model="menu" left bottom :close-on-content-click="false" transition="scale-transition">
            <v-btn slot="activator" dark icon>
                <v-icon>account_box</v-icon>
            </v-btn>

            <v-card>
                <!-- <v-list>
                    <v-list-tile avatar>
                        <v-list-tile-avatar>
                            <img :src="form.CompanyLogo">
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title>{{ form.CompanyName }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>

                <v-divider></v-divider> -->

                <v-list>
                    <!-- <v-list-tile v-if="HasAccess('ACCOUNT', 'VIEW')" @click="$router.push('/account')">
                        <v-list-tile-title>
                            <v-icon>account_box</v-icon> {{TranslateText("Account")}}
                        </v-list-tile-title>
                    </v-list-tile> -->

                    <v-list-tile @click="$router.push('/login')">
                        <v-list-tile-title>
                            <v-icon>exit_to_app</v-icon>Logout
                        </v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
    import JWT from 'jsonwebtoken'

    export default {
        data: () => ({
            fav: true,
            menu: false,
            message: false,
            hints: true,
            form: {
                ID: null,
                CompanyName: null,
                CompanyLogo: null,
                EmailAddress: null,
                PhoneNumber: null,
                StreetAddress: null,
                City: null,
                CountryCode: null
            },
        }),
        mounted() {
            let self = this;

            //self.FetchData();
        },
        methods: {
            FetchData() {
                let self = this;
                let AccountID = JWT.decode(sessionStorage['accessToken']).ACCOUNT_ID;

                self.get("/Account?id=" + AccountID)
                    .then(response => {
                        console.log(response)
                        self.form.ID = response.data.ID;
                        self.form.CompanyName = response.data.CompanyName;
                        self.form.CompanyLogo = 'data:image/png;base64,' + response.data.CompanyLogo;
                        self.form.EmailAddress = response.data.EmailAddress;
                        self.form.PhoneNumber = response.data.PhoneNumber;
                        self.form.StreetAddress = response.data.StreetAddress;
                        self.form.City = response.data.City;
                        self.form.CountryCode = response.data.CountryCode;
                    })
            },
        }
    }
</script>

<style>

</style>